 var save_id = 0;
 var cpt_save = 0;
 var from_range = false; //for wishlist

 function addEvent(elem, event, name_function) {
    if (document.all) elem.attachEvent("on" + event, name_function);
     else elem.addEventListener(event, name_function, false);
 }

 function delEvent(elem, event, name_function) {
     if (document.all) elem.detachEvent("on" + event, name_function);
     else elem.removeEventListener(event, name_function, false);
 }

// // empeche les evenements de remonter dans l'arbre

 function doNothing(e) {
     if (document.all) {
         if (!e) var e = window.event;
         e.cancelBubble = true;
     } else {
         e.stopPropagation();
     }
     return false;
 }
 // popup guide des tailles
 function showsizeguide(){
     var elname = 'sizeguidebox';
     var actualposition = document.documentElement.scrollTop;
     var modbox = document.getElementById(elname);
     var shade = document.getElementById('shade');
     modbox.style.position = "absolute";
     shade.style.display="block";
     addEvent(shade,'click',closesizeguide);

     addEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);

     modbox.style.display="block";

     window.scrollTo(0,actualposition);
 }

 function closesizeguide() {
     var elname = 'sizeguidebox';
     var shade = document.getElementById('shade');
     var modbox = document.getElementById(elname);
     modbox.style.display="";

     delEvent(shade,'click',closesizeguide);
     delEvent(modbox,'click',closesizeguide);
     delEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);
     closemodal();
 }

 function newshowmodal(products, type, root, id_produit, is_not_produit)
 {
     topCartAppear();
     window.setTimeout(function () {

         topCartDesappear();
     }, 5000);
 }

 function closemodal() {
     var modbox = document.getElementById("modbox");
     var errbox = document.getElementById("errbox");
     var cmodbox = document.getElementById("cmodbox");
     var shade = document.getElementById("shade");

     if (cmodbox) {
         cmodbox.innerHTML = "";
     }

     if (modbox) {
         modbox.style.marginLeft = "";
         modbox.style.display = "none";
     }

     if (shade) {
         shade.style.display = "none";
     }

     if (errbox) {
         errbox.style.display = "none";
     }

     document.body.style.overflow = "";
     document.getElementsByTagName("html")[0].style.overflow = "";

     if (
         navigator.userAgent.indexOf("MSIE") != -1 &&
         navigator.userAgent.indexOf("6.") != -1
     ) {
         var svn = document.getElementsByTagName("SELECT");
         for (a = 0; a < svn.length; a++) {
             svn[a].style.visibility = "visible";
         }
     }
 }

 function waitingAddToBasket(evt, form_elm, from, itm_rr_id) {

     var id = '';
     var produit_id = form_elm.getValue('produit_id');
     var suff = form_elm.getValue('suff');
     var panier_id = form_elm.getValue('panier_id');
     var titreObjet = form_elm.getValue('titreObjet');
     var idTaille = form_elm.getValue('idTaille');
     var lastTaille = form_elm.getValue('lastTaille');
     var idCouleur = form_elm.getValue('idCouleur');
     var lastCouleur = form_elm.getValue('lastCouleur');
     var toEval = form_elm.getValue('toEval');
     var page_name = form_elm.getValue('page_name');
     var path_web = form_elm.getValue('path_web');
     var enable_omniture = form_elm.getValue('enable_omniture');
     var is_not_produit = form_elm.getValue('is_not_produit');
     var is_lightbox_specifique = form_elm.getValue('is_lightbox_specifique');
     var is_achat_express = $('#is_achat_express_v2').val() == 1;
     var loader;

     if(!is_achat_express)
         evt.preventDefault();

     if (from === undefined) {

        from = '';
     }

     if (is_not_produit == true) {

         id += '_' + produit_id;
     }

     if (this.nextElementSibling && this.nextElementSibling.classList.contains('loader')) {

         loader = $(this.nextElementSibling);

         loader.addClass("loading");

     } else {

         $("#bloc_btn_active" + id).attr('class', 'cache');
         $("#bloc_btn_loader" + id).attr('class', 'f_right');
     }

     if (is_lightbox_specifique == 'true') {

         add_produit_specifique(produit_id, idCouleur, idTaille);
     } else {

         window.setTimeout(addToBasket, 1000, produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id);
     }
 }

 function addToBasket(produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id) {

     var id = '';

     prix_id = 'prixU';

     if (from == 'basket' || is_not_produit == true || is_achat_express) {

         id += '_' + produit_id + itm_rr_id;
         prix_id = 'prixU' + id;

         if (is_not_produit == true) {

             var code_color = $('#couleurUnique' + id).text();
             var nom_color = $('#couleurUnique' + id).text();
         }
     }

     var array_panier = newUpdatePanier(produit_id, suff, panier_id, document.getElementById(prix_id).value, path_web, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur);

     if (array_panier != false) {

         if (from == 'basket') {

             location.reload();

             return false;
         }

         var type = '';

         if (array_panier[1] == 'false' || array_panier.length == 0) {

             type = 'err';
         }

         omnitureEvent = '';

         if (array_panier[1] == 1) {

             omnitureEvent = 'scOpen,scAdd'; // le premier produit ajout� au panier
         } else {

             omnitureEvent = 'scAdd'; // il y a d�j� un produit au panier
         }

         if (loader) {

            loader.parent().removeClass('loading');
            loader.removeClass('loading');


         } else {

             $("#bloc_btn_active" + id).attr('class', '');
             $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
         }

         if (array_panier[1] > 0 && enable_omniture == true) {

             void(s.t());
             s.pageName = "'" + page_name + "'";
             s.products = ";" + produit_id;
             s.events = omnitureEvent;
             void(s.t());
         }

         // DATALAYER V2
         if (array_panier.length >= 0 && array_panier[5] !== undefined) {
             pushIntoDatalayer(array_panier[5]);
         }

         // Mise à jour du panier top
         var response_basket = ajax_file(path_web + 'ajax_show_basket.php');

         $("#cart_top").html(response_basket);

         var count_bask = $('#cart_top .cart').attr('data-cart');

         $("#lightbox_achat_express, .lightbox_achat_express, #shad").hide();

        if($('.page_rayon.rayon_lookbook').length) {
            $('body').css('overflow','');
        }

         newshowmodal(produit_id, is_not_produit);
     } else {

         if (loader) {

             loader.parent().removeClass('loading');
         } else {

             $("#bloc_btn_active" + id).attr('class', '');
             $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
         }
     }

     eval(toEval);

     if (array_panier != false) {

         if (navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1) {

             var svn = document.getElementsByTagName("SELECT");

             for (a = 0; a < svn.length; a++) {

                 svn[a].style.visibility = "hidden";
             }
         }
     }

     return false;
 }

 function displayZoom(
     picture,
     product_ref,
     path_web,
     picture_medium,
     picture_mini,
     photo_path,
     photo_list
 ) {
     var so = new SWFObject(
         path_web + "zoom.swf",
         "zoom",
         "405",
         "610",
         "8",
         "#FFFFFF"
     );
     so.addParam("wmode", "transparent");
     so.addParam("allowScriptAccess", "always");
     so.addVariable("produit_id", product_ref);
     so.addVariable("url", path_web);

     so.addVariable("photo_path_medium", picture_medium);
     so.addVariable("photo_path_mini", picture_mini);

     so.addVariable("photo_path", photo_path);

     so.addVariable("photo_list", photo_list);
     so.addVariable("img_defaut", picture);
     so.write("flashVisuel");
 }

 function zoom(
     picture,
     product_ref,
     path_web,
     picture_medium,
     picture_mini,
     photo_path,
     photo_list
 ) {
     displayZoom(
         picture,
         product_ref,
         path_web,
         picture_medium,
         picture_mini,
         photo_path,
         photo_list
     );
 }

 function zoomImg(slide) {
     $('#zoom_box_wrapper').css('opacity', 0);
     window.setTimeout(function () {

        if($("#thumbs_scroller").length > 0) {
            var zoomThumbs = new Swiper('#thumbs_scroller', {
                slidesPerView: 'auto',
                initialSlide: slide - 1,
                spaceBetween: 14,
                direction: 'vertical',
                mousewheel: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
        }
        
        if($("#zoom_box_wrapper .swiper-slide").length > 0) {
            var main_productZoom = new Swiper('#zoom_box_wrapper', {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                slidesPerView: 1,
                initialSlide: slide - 1,
                mousewheel: false,
                navigation: {
                    nextEl: '.thumbsNext',
                    prevEl: '.thumbsPrev',
                },
                thumbs: {
                    swiper: zoomThumbs
                },
                on: {
                    init: function() {
                        loadVisibleImages(this);
                    },
                    slideChange: function() {
                        loadVisibleImages(this);
                    }
                }
            });
        }
     }, 50);

     window.setTimeout(function () {
         $('#zoom_box_wrapper').animate({opacity: 1}, 650);
     }, 350);

     openMultiShad('zoomBox');
 }


 function updateSrc(path_web, dest) {
     var tmp_string_large = document.getElementById("img_large").src;
     tmp_string = tmp_string_large.replace(/medium/, "large");

     document
         .getElementById("img_large")
         .setAttribute(
             "onclick",
             "zoomImg('" + tmp_string + "','" + path_web + "')"
         );
     document.getElementById("loupe").href =
         "javascript:zoomImg('" + tmp_string + "','" + path_web + "');";
     $(".zoomLens").css({backgroundImage: 'url("' + tmp_string_large + '")'});

     if (dest == "vue") {
         var i = 0;
         var trouve = false;
         while (i < tab_js.length && !trouve) {
             trouve =
                 tab_js[i][0].substring(tab_js[i][0].lastIndexOf("/") + 1) ==
                 tmp_string.substring(tmp_string.lastIndexOf("/") + 1);
             i++;
         }

         cpt_img = i - 1;
     }
 }

 function show_lightbox(lightbox_contact) {
     $("#shad")
         .fadeTo("slow", 0.8)
         .queue(function() {
             $("#" + lightbox_contact).slideDown("slow", function() {
                 $("#visu_popup_ajout_panier", this).recalImg();
             });

             $(this).dequeue();
         })
         .click(function() {
             close_lightbox(lightbox_contact);
         });

     $("html, body").animate({scrollTop: 0}, $(document).scrollTop() * 0.8);
 }

 function close_lightbox(lightbox_contact) {
     $("#" + lightbox_contact)
         .slideUp("slow")
         .queue(function() {
             $("[id^=shad]").each(function() {
                 if ($(this).is(":visible")) {
                     $(this).fadeTo("slow", 0, function() {
                         $(this).css("display", "none");
                     });
                 }
             });

             $(this).dequeue();
         });
 }

/* Dans la fiche produit affiche un champs email pour que l'ont previenne que le produit est disponible */
function lightboxAlertStock(element) {
    // On isole le formulaire ou le conteneur produit
    var containerProduit = $(element).closest('.product_info'); 
    if (containerProduit.length === 0) {
        containerProduit = $(element).closest('.bloc_add_alert').parent();
    }

    // Récupération des valeurs sélectionnées
    var idTailleSelectionnee = containerProduit.find("input[name='tailleProd']").val();
    var idCouleurSelectionnee = containerProduit.find("input[name='couleurProd']").val();
    var idProduitPrincipal = containerProduit.find("input[name='produit_id']").val();

    // Validation : si aucune taille n'est choisie
    if (!idTailleSelectionnee) {
        var messageErreurTaille = containerProduit.find('#sizeerror');
        if (!messageErreurTaille.is(':visible')) {
            messageErreurTaille.slideDown();
        }
        return;
    }

    // Éléments de l'interface d'alerte
    var blocAlerte = $(element).closest('.bloc_add_alert');
    var composantVueStock = blocAlerte.find('.js-stock-component');
    var messageConfirmation = blocAlerte.find('.bloc_add_alert_confirmation');
    var messageErreurAjax = blocAlerte.find('.bloc_add_alert_erreur');

    // Comportement Toggle (Afficher/Masquer)
    if (composantVueStock.is(':visible') || messageConfirmation.is(':visible') || messageErreurAjax.is(':visible')) {
        composantVueStock.slideUp('fast');
        messageConfirmation.slideUp('fast');
        messageErreurAjax.slideUp('fast');
    } else {
        var estComposantVide = composantVueStock.html().trim() === "";
        var estVueDisponible = typeof Vue !== 'undefined' && typeof wAlertestockForm !== 'undefined';

        if (estComposantVide && estVueDisponible) {
            new Vue({
                el: composantVueStock[0],
                render: h => h(wAlertestockForm, {
                    props: {
                        productId: idProduitPrincipal,
                        initialSize: idTailleSelectionnee, 
                        initialColor: idCouleurSelectionnee,
                        email: composantVueStock.attr('email'),
                        typeAlert: composantVueStock.attr('type-alert'),
                        achatExpress: 'true'
                    }
                })
            });
        }

        composantVueStock.slideDown('fast');
    }
}

/*
 * Permet l'envoi du mail qui confirme l'enregistrement de sont email, pour alerter la personne quand le produit sera disponible
 */
function sendMailAlertStock (type_alert, form, itm_rr_id) {

    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';
    var id= form.getValue('produit_id');
    var is_achat_express = $('#is_achat_express_v2').val() !== undefined;
    var elem = is_achat_express ? '_' + id + itm_rr_id : '';

    var $email = $('#mail_alerte_stock' + elem).val(),
        $produit_id = $('#produit_principal' + elem).val(),
        $taille_id = $("#tailleProd" + elem).val(),
        $couleur_id = $("#couleurProd" + elem).val(),
        $type_alert = type_alert;

    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mail_value = $('#mail_alerte_stock' + elem).val();
    $verif_mail = mail_value.match(mailformat);

    if ($email == '' || !$verif_mail) {

        $('#mail_alerte_stock' + elem).addClass('inputErr');
    } else {

        $('#mail_alerte_stock' + elem).removeClass('inputErr');
        $.ajax({
            type : 'post',
            url : path_relative_root + create_link('ajax_mail_alert_stock'),
            data : {
                email : $email,
                produit_id : $produit_id,
                taille_id : $taille_id,
                couleur_id : $couleur_id,
                type_alert : $type_alert
            },
            success : function(response) {
                $('.bloc_add_alert' + elem + ' .alert_stock').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_erreur').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_form').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_confirmation').show();
            },
            fail : function () {
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_confirmation').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_erreur').show();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_form').show();
            }
        });
    }
}

// popup PDV
function showpdv() {

    var shade, modbox, contents;

    $.ajax({
        type : 'post',
        url : path_relative_root + create_link('ajax_search_shop'),
        success : function (res) {

            if (res) {

                shade = document.getElementById('shad');
                modbox = document.getElementById('pdvBox');

                contents = $('<div />').html(res);

                // Make sure modbox will show on top of shade
                $(shade).after(modbox);

                // Inject store locator into modbox
                $('.store_locator', modbox).html($('.storeloc_form', contents).add($('.liste_recherche_distributeur', contents)));

                initialize();

                // Show modbox and make sure closing routine won't fire more than once
                $(shade).off('click', closepdv).fadeIn(200, function () {

                    $(modbox).slideDown(600);
                    $(shade).on('click', closepdv);

                    // Init locator
                    if (navigator.geolocation) {
                        var crd = navigator.geolocation.getCurrentPosition(rechercheProximite);
                    }
                });
            }
        }
    });
}

function closepdv() {

    var shade = document.getElementById('shad');
    var modbox = document.getElementById('pdvBox');

    // Hide modbox and shade and destroy shade's click event
    $(modbox).slideUp(600, function () {

        $(shade).off('click', closepdv).stop(true, true).fadeOut(200);
    });
}

$('.product_feats_wrapper, .form_submit.dispo_magasin,  #chez_vous_le, .share_wrapper').appendTo('.product_info_wrapper');

$('.prod_top_wrapper').fadeIn();

// /*Page sliders*/
if($("#visual_scroller").length) {
    var productThumbs = new Swiper('#visual_scroller', {
        slidesPerView: 'auto',
        spaceBetween: 22,
        direction: 'vertical',
        freeMode: true,
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.thumbNext',
            prevEl: '.thumbPrev',
        },
        breakpoints: {
            1024: {
                direction: 'horizontal',
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1161: {
                direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 22,
            },
        },
    
        // stop the swiper 4 slides before the real end
        on: {
            init: function() { updateStopBefore(this, 3); },
            slideChange: function() { updateStopBefore(this, 3); },
            resize: function() { updateStopBefore(this, 3); }
        }
    });
}
function updateStopBefore(swiper, stopBefore) {
    // security for it doesn't work with loop = true
    if (swiper.params.loop) return;

    var totalSlides = swiper.slides.length;
    var stopIndex = Math.max(0, totalSlides - stopBefore - 1); // index on which to stop
    // Prevent to go to slide next slide if limit reached
    swiper.allowSlideNext = !(swiper.activeIndex >= stopIndex);
}

if($("#visual_scroller .swiper-slide").length < 4) {
    $('.more_vis').addClass('few_pics');
}

if($(".product_page .main_vis_fp_swiper .swiper-slide").length <= 3) {
    var main_productVisu = new Swiper('.product_page .main_vis_fp_swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        loop: false,
        navigation: {
            nextEl: '.thumbNext',
            prevEl: '.thumbPrev',
        },
        thumbs: {
            swiper: productThumbs
        },

        breakpoints: {
            1160: {
                direction: 'horizontal',
            },
        },
        preloadImages: false,
        loadPrevNext: true,
        loadOnTransitionStart: true,

        on: {
            slideChange: function() {
                var activeSlide = this.slides[this.activeIndex];
                loadDataSrcImages(activeSlide);
            },
            
            init: function() {
                var activeSlide = this.slides[this.activeIndex];
                loadDataSrcImages(activeSlide);
                
                var nextIndex = (this.activeIndex + 1) % this.slides.length;
                var nextSlide = this.slides[nextIndex];
                if (nextSlide) {
                    loadDataSrcImages(nextSlide);
                }
            }
        }
    });
}

if($(".product_page .main_vis_fp_swiper .swiper-slide").length > 3) {
    var main_productVisu = new Swiper('.product_page .main_vis_fp_swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        loop: true,
        navigation: {
            nextEl: '.thumbNext',
            prevEl: '.thumbPrev',
        },
        thumbs: {
            swiper: productThumbs
        },

        breakpoints: {
            1160: {
                direction: 'horizontal',
            },
        },
        preloadImages: false,
        loadPrevNext: true,
        loadOnTransitionStart: true,

        on: {
            slideChange: function() {
                var activeSlide = this.slides[this.activeIndex];
                loadDataSrcImages(activeSlide);
            },
            init: function() {
                var activeSlide = this.slides[this.activeIndex];
                loadDataSrcImages(activeSlide);
                
                var nextIndex = (this.activeIndex + 1) % this.slides.length;
                var nextSlide = this.slides[nextIndex];
                if (nextSlide) {
                    loadDataSrcImages(nextSlide);
                }
            }
        }
    });
}

$('.product_page .main_vis_fp_swiper .swiper-slide').click(function(){
   $('body').css('overflow', 'hidden');
});


 $('#zoom_box_wrapper .swiper-slide, #zoomBox .close_pop').click(function(){
    $('body').css('overflow', 'auto');
 });

$(document)
    .off('click', '.bloc_add_alert_confirmation button, #bloc_add_alert #btn_add_alert')
    .on('click', '.bloc_add_alert_confirmation button, #bloc_add_alert #btn_add_alert', function() {

        var lightbox_achat_express = $(this).closest('#lightbox_achat_express, div.page_produit');

        if ($(this).is('#bloc_add_alert #btn_add_alert')) {
            $(this).hide();
            lightbox_achat_express.find('.bloc_add_alert_form').hide();
            lightbox_achat_express.find('.bloc_add_alert_form').show();
        }

        if ($(this).is('.bloc_add_alert_confirmation button')) {
            lightbox_achat_express.find('#bloc_add_alert #btn_add_alert').show();
        }
    });

$(window).on('load resize', function () {
    // Gondole
    window.setTimeout(function() {
        initSwiperClasses('complete_look', 'productAssociationSwiper');
        initSwiperClasses('gondole_aimerez', 'categoryAssociationSwiper');
    }, 1000);
});

function initSwiperClasses(idBlock, swiperBlock)
{
    var w = $(window).width();
    if (w < 1366) {
            $('#' + idBlock).addClass('small_swiper');
            
        if($("#" + swiperBlock + " .swiper-slide.item").length > 2) {
                $('#' + swiperBlock).addClass('swiper_on');
            
        } else {
            $('#' + swiperBlock).addClass('no_swiper');
            $('#' + swiperBlock).removeClass('swiper_on');
        }
    }
    else {
        if($("#" + swiperBlock + " .swiper-slide.item").length > 4) {
            $('#' + idBlock).removeClass('small_swiper');
            $('#' + swiperBlock).addClass('swiper_on');
        } else {
            $('#' + swiperBlock).addClass('no_swiper');
            $('#' + swiperBlock).removeClass('swiper_on');
        }
    }
}

 /**
  * Disable add to cart btn and display a rollover text information.
  */
 function disableAddCart() {

     "use strict";

     var addCartWrapper = $(".btnAddBasketWrapper");
     var addCartBtn = $(".btnAddBasket");

     addCartWrapper.addClass("inactiv");
     addCartWrapper.removeClass("active_btn");
     addCartBtn.prop("disabled", true);
     $( "#sizeerror" ).css('opacity', '1');
 }

 /**
  * Enable add to cart btn
  */
 function enableAddCart() {

     "use strict";

     var addCartWrapper = $(".btnAddBasketWrapper");
     var addCartBtn = $(".btnAddBasket");
     var disabledBtnInfos = $(".disabledBtnInfos");

     disabledBtnInfos.text("");
     addCartWrapper.removeClass("inactiv");
     addCartWrapper.addClass("active_btn");
     addCartBtn.prop("disabled", false);

     $( "#sizeerror" ).css('opacity', '0');
 }

window.setTimeout(function() {
    $("#bloc_add_basket.inactiv, #addToWishlistButton").on("click", () => {
        if ($("input[name='itm_size']:checked").length === 0) {
            // Scroll to the item name
            $("html, body")
                .delay(100)
                .animate({
                    scrollTop: $("#itm_name").offset().top
                }, 2000);

            $(".disabledBtnTooltip").addClass("actif");
        }
    });

    $( ".prod_btn_wrapper .inactiv" )
    .mouseover(function() {
        $( "#sizeerror:not(.active_btn)" ).addClass('show');
    })
    .mouseout(function() {
        $( "#sizeerror" ).removeClass('show');
    });

 }, 1000);


/***********
FP Color
***********/
$(document).ready(function() {
    $('#ligne_couleur').mouseover(function(e) {
    e.preventDefault();
        $('#ligne_couleur .js-dropp-action').addClass('drop_button');
        $('.choices_list.choice_color').addClass('js-visible');
        $('#ligne_couleur .drop_btn_big:not(".no_dropdown")').addClass('opened');
        $('.choices_list.size').removeClass('js-visible');
        $('#ligne_pointure .js-dropp-action').removeClass('drop_button');
        $('#ligne_couleur').removeClass('closed');
    });

    $('#ligne_couleur').mouseout(function(){
        $('#ligne_couleur .js-dropp-action').removeClass('drop_button');
        $('.choices_list.choice_color').removeClass('js-visible');
        $('#ligne_couleur').addClass('closed');

        window.setTimeout(function() {
            $('#ligne_couleur.closed .simplebar-content-wrapper').animate({ scrollTop: 0 }, "fast");
        }, 1500);
    });

    // Using as fake input select dropdown
    $('#ligne_couleur input').click(function() {
        $(this).addClass('js-visible').siblings().removeClass('js-visible');
        $('.choices_list.color,#ligne_couleur .js-dropp-action').removeClass('js-visible');
        $('#ligne_couleur .drop_btn_big').removeClass('opened');
        $(this).parent().addClass('active').siblings().removeClass('active');
    });

    $('.choices_list.choice_color .input_check').click(function() {
        $('#ligne_couleur .dropp-header__btn').removeClass('drop_button');
        $('.choices_list.choice_color.js-visible').removeClass('js-visible');
        $('#ligne_couleur .drop_btn_big').removeClass('opened');
        $('.choices_list.choice_color').addClass('color_selected');
    });

    $('#ligne_couleur .dropp-header__btn').click(function() {
        $('.choices_list.choice_color.color_selected').removeClass('color_selected');
    });

    $('#ligne_couleur .prod_listes .choices_list .form_itm.color input:checked').parent('.form_itm').addClass('active');

    window.setTimeout(function() {
        $('#ligne_couleur .dropp .choices_list .form_itm.color').css('opacity','1');
    }, 500);

    $(document).on('click', '#retour_product .btn_retour', handleDesktopProductBack);
});

function handleDesktopProductBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var breadcrumbLinks = document.querySelectorAll('#breadcrumbs .breadcrumb a');
    var objectLevelLink = breadcrumbLinks[breadcrumbLinks.length - 1];

    if (objectLevelLink) {
        window.location.assign(objectLevelLink.href);
        return;
    }

    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(homeUrl);
}